import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import * as Turbo from "@hotwired/turbo";
import { attachCancelButtonConfirmation } from "../helpers";
import { trackEvent } from "../../Features/Analytics";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";
import { TourType } from "../_generated/TourType";

export default class CreateController extends Controller {
    static targets = [
        "form",
        "tourType",
        "indoorHint"
    ];
    static values = {
        getJobUrl: String,
        tourDetailUrl: String
    }

    readonly formTarget!: HTMLElement;
    readonly tourTypeTarget!: HTMLSelectElement;
    readonly indoorHintTarget!: HTMLElement;

    readonly getJobUrlValue!: string;
    readonly tourDetailUrlValue!: string;

    connect() {
        const form = $(this.formTarget);

        formSubmitWithWaitForJobCompletion(
            form,
            $("#submit"),
            this.getJobUrlValue,
            () => {
                trackEvent('tourCreated');
                Turbo.clearCache();
                Turbo.visit(this.tourDetailUrlValue);
            }
        );

        const tourType = $(this.tourTypeTarget);
        selectize(tourType, {
            score: getScoreFunctionPreservingOrderInSearch,
            onChange: () => this.onTourTypeChanged()
        });

        attachCancelButtonConfirmation();
    }

    onTourTypeChanged() {
        this.indoorHintTarget.style.display = this.tourTypeTarget.value === `${TourType.Indoor}`
            ? "block"
            : "none";
    }
}
